import { render, staticRenderFns } from "./ZoneManagement.vue?vue&type=template&id=8d20080c"
import script from "./ZoneManagement.vue?vue&type=script&lang=js"
export * from "./ZoneManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports